import { applyThemeColors, getThemeColor, createThemeStyles } from '@/utils/themeUtils'

export default {
  data () {
    return {
      themeColors: null
    }
  },
  computed: {
    // Get theme colors from userData in store
    userThemeColors () {
      return this.$store.state.userData && this.$store.state.userData.themeColors
        ? this.$store.state.userData.themeColors
        : null
    },
    // Create CSS styles object for inline styling
    themeStyles () {
      return createThemeStyles(this.userThemeColors)
    }
  },
  methods: {
    // Apply theme colors to the document
    applyThemeColors () {
      if (this.userThemeColors) {
        applyThemeColors(this.userThemeColors)
        this.themeColors = this.userThemeColors
      }
    },
    // Get a specific theme color with fallback
    getThemeColor (colorKey, fallback = '#000000') {
      return getThemeColor(colorKey, this.userThemeColors, fallback)
    },
    // Update theme colors (when they change)
    updateThemeColors (newThemeColors) {
      if (newThemeColors) {
        // Update userData in store
        const updatedUserData = {
          ...this.$store.state.userData,
          themeColors: newThemeColors
        }
        this.$store.commit('setUserDataToLocalStorage', updatedUserData)
        // Apply the new colors
        this.applyThemeColors()
      }
    }
  },
  mounted () {
    // Apply theme colors when component mounts
    this.applyThemeColors()
  },
  watch: {
    // Watch for changes in userData.themeColors
    userThemeColors: {
      handler (newThemeColors) {
        if (newThemeColors) {
          this.applyThemeColors()
        }
      },
      deep: true
    }
  }
}
